enum RUMJSEventType {
  Info,
  Warning,
  Error,
  Critical
}

enum RUMJSEventDataType {
  JSError,
  VueWarn,
  VueError
}

class RUMJSError {
  public Name: string;
  public StackTrace: string | undefined;
  public Message: string;

  constructor(name: string, message: string, stackTrace: string | undefined) {
    this.Name = name;
    this.StackTrace = stackTrace;
    this.Message = message;
  }
}

class RUMVueWarn {
  public StackTrace: string;
  public Message: string;

  constructor(message: string, stackTrace: string) {
    this.StackTrace = stackTrace;
    this.Message = message;
  }
}

class RUMVueError {
  public StackTrace: string;
  public Message: string;

  constructor(message: string, stackTrace: string) {
    this.StackTrace = stackTrace;
    this.Message = message;
  }
}

class RUMJSEvent {
  public Type: RUMJSEventType;
  public DataType: RUMJSEventDataType;
  public Data: any;

  constructor(type: RUMJSEventType, dataType: RUMJSEventDataType, data: any) {
    this.Type = type;
    this.DataType = dataType;
    this.Data = data;
  }

  static FromDOMError(error: Error) {
    return new RUMJSEvent(RUMJSEventType.Error, RUMJSEventDataType.JSError, new RUMJSError(error.name, error.message, error.stack));
  }

  static FromVueWarn(error: string, stack: string) {
    return new RUMJSEvent(RUMJSEventType.Warning, RUMJSEventDataType.VueWarn, new RUMVueWarn(error, stack));
  }

  static FromVueError(error: string, stack: string) {
    return new RUMJSEvent(RUMJSEventType.Error, RUMJSEventDataType.VueError, new RUMVueError(error, stack));
  }
}

export { RUMJSEvent, RUMJSEventType, RUMJSEventDataType }
